module.exports = __webpack_public_path__ + "static/media/betterment.13a6c37c.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/images/companies/betterment.png
 ** module id = 424
 ** module chunks = 0
 **/